import goalSettingsStepsSchema from './GoalSettings/stepsSchema';
import dietSettingsStepsSchema from './DietSettings/stepsSchema';
import biometricSettingsStepsSchema from './BiometricSettings/stepsSchema';

import packageJson from '../package.json';
export const ALLOWED_LANGUAGES = ['en-US', 'pt-BR'];

export const SENTRY_DSN =
  'https://29623541bb4ed24e1bb2d30d64def96d@o251048.ingest.us.sentry.io/4509388992872448';

export const APP_STORE_URL = 'https://radiance.onelink.me/ekRU/stbruh4g';
export const GOOGLE_PLAY_URL = 'https://radiance.onelink.me/ekRU/stbruh4g';

export const APP_VERSION = packageJson.version;
export const APP_BRAND = 'radiance';

export const GTM_ID = '';

export const SLIDE_ROUTES_DURATION = 350;

export const LANDING_URL = 'https://join.radiance.com/';

export const siteMetadata = {
  lang: 'en',
  shortName: 'radiance',
  name: 'radiance',
  themeColor: '#ffffff',
  title: 'Radiance',
  description: '',
  keywords: ['radiance'],
  author: 'activerse.app',
};

export const INSTACART_FIREBASE_FUNCTION =
  'https://radianceinstacartgenerator-n4urty5wva-uc.a.run.app';
export const INSTACART_URL = 'https://www.instacart.com/store/partner_recipes';

export const FRISCO = false;

export const FIRST_DIET_SETTINGS_STEP_SLUG = dietSettingsStepsSchema[0].slug;
export const FIRST_GOAL_SETTINGS_STEP_SLUG = goalSettingsStepsSchema[0].slug;
export const FIRST_BIOMETRIC_SETTINGS_STEP_SLUG = biometricSettingsStepsSchema[0].slug;

export const FORCE_BUILD = true;
